import api from './api.service';

export interface OwnerSettings {
  id?: string;
  userId?: string;
  acceptanceEmailTemplate: string | null;
  rejectionEmailTemplate: string | null;
  defaultAcceptanceEmailTemplate: string;
  defaultRejectionEmailTemplate: string;
}

class OwnerSettingsService {
  async get(): Promise<OwnerSettings> {
    const response = await api.get('/owner-settings/');
    return response.data;
  }

  async update(data: { acceptance_email_template?: string | null; rejection_email_template?: string | null }): Promise<OwnerSettings> {
    const response = await api.put('/owner-settings/', data);
    return response.data;
  }
}

export const ownerSettingsService = new OwnerSettingsService();
